import { render, staticRenderFns } from "./AllEvent.vue?vue&type=template&id=1800ef64&"
import script from "./AllEvent.vue?vue&type=script&lang=js&"
export * from "./AllEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports